import orbitLogoUrl from "./assets/orbit-icon.png";

export const ORBIT_LOGO_SRC = orbitLogoUrl;
